let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iHwLj")).then(() => parcelRequire('a6h8L'));